<svg:svg
    [attr.width]="24 * 6"
    [attr.x]="dimensions.boundedWidth"
    [attr.y]="7 * this.dimensions.marginTop"
>
    <svg:svg
        class="color-picker"
        [attr.width]="24 * 6"
        height="24"
        (click)="onClickOpen()"
    >
        <svg:rect
            [style.fill]="brewer[selectedPalette][2 * idx]"
            width="24"
            height="24"
            [attr.x]="idx * 24"
            *ngFor="let idx of numbers"
        ></svg:rect>
        <svg:svg height="24" width="24" [attr.x]="24 * 5" viewBox="0 0 24 24">
            <svg:path d="m 13,6 -5,5 -5,-5 z" fill="#797979" *ngIf="!open" />
            <svg:path d="m 3,10 5,-5 5,5 z" fill="#797979" *ngIf="open" />
        </svg:svg>
    </svg:svg>
    <svg:g class="color-chooser" *ngIf="open">
        <svg:svg
            [attr.y]="(i + 1) * (24 + 2)"
            [attr.width]="24 * 6"
            [attr.height]="24 + 2"
            *ngFor="let palette of palettes; index as i"
            (click)="onSelectedPaletteChanged(palette)"
        >
            <svg:rect
                [style.fill]="brewer[palette][2 * idx]"
                width="24"
                height="24"
                [attr.x]="idx * 24"
                *ngFor="let idx of numbers"
            ></svg:rect>
        </svg:svg>
    </svg:g>
</svg:svg>
